define('exq-admin/tests/helpers/start-app', ['exports', 'ember', 'exq-admin/app', 'exq-admin/router', 'exq-admin/config/environment'], function (exports, _ember, _exqAdminApp, _exqAdminRouter, _exqAdminConfigEnvironment) {
  exports['default'] = startApp;

  function startApp(attrs) {
    var App;

    var attributes = _ember['default'].merge({}, _exqAdminConfigEnvironment['default'].APP);
    attributes = _ember['default'].merge(attributes, attrs); // use defaults, but you can override;

    _exqAdminRouter['default'].reopen({
      location: 'none'
    });

    _ember['default'].run(function () {
      App = _exqAdminApp['default'].create(attributes);
      App.setupForTesting();
      App.injectTestHelpers();
    });

    App.reset(); // this shouldn't be needed, i want to be able to "start an app at a specific URL"

    return App;
  }
});